import PeopleTablev2 from "./PeopleTablev2";

export default PeopleTablev2;
